export const REGEX = {
	EMAIL: '^([-A-Za-z0-9_.])+@([-A-Za-z0-9_])+([.]{1})([A-Za-z]{2,4})$',
	PAN: '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$',
	AADHAR: '(^\\d{12}$)|(^\\d{4}-\\d{4}-\\d{4}$)|(^\\d{4} \\d{4} \\d{4}$)',
	GST: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$',
	IFSC: '^[a-zA-Z]{4}0[0-9a-zA-Z]{6}',
	ONLY_NUM: '^[0-9]*$',
	ONLY_ALPHA: '^[A-Za-z]+$',
	ALPHA_NUMERIC: '^[a-zA-Z0-9]',
	ALPHA_SPACE: '^^[A-Za-z0-9 ]+$',
	ADDRESS: '^[-a-zA-Z0-9, ]',
	UPI: '[a-zA-Z0-9.-]{2,256}@[a-zA-Z][a-zA-Z]{2,64}',
	PINCODE: /[^\d/]/gi,
	ADDRESS: /^[^a-zA-Z0-9#]{1}[a-zA-Z0-9\s\,\\\/\-\.\#\@\&\:\;\(\)\'\+\_\"]*\w*$/i,
	EMAIL_ADDRESS:
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

var handleValidation = {
	validate: function (validationType, value, minLength) {
		console.log(new RegExp(REGEX[validationType.toUpperCase()]).test(value));
		return !(value.length >= minLength) ? false : new RegExp(REGEX[validationType.toUpperCase()]).test(value);
	},
};

export default handleValidation;
